import { NgModule } from '@angular/core';

import { VirtualScrollComponent } from './virtual-scroll.component';

@NgModule({
    declarations: [VirtualScrollComponent],
    exports: [VirtualScrollComponent],
})
export class CmpsVirtualScrollModule {}
